import { defineRule } from 'vee-validate'
import { email, max, min, required } from '@vee-validate/rules'

const MIN_PASSWORD_LENGTH = 6

function validatePassword(value: string) {
  const NUMBER_REGEX = /\d/
  const UPPERCASE_REGEX = /[A-Z]/
  const LOWERCASE_REGEX = /[a-z]/
  const SPECIAL_CHAR_REGEX = /[ `!@#$%^&*()_+=[\]{};':"\\|,.<>/?~-]/

  const errorMessage: string[] = []

  if (!min(value, { length: MIN_PASSWORD_LENGTH })) {
    errorMessage.push(`at least ${MIN_PASSWORD_LENGTH} characters`)
  }

  if (!NUMBER_REGEX.test(value)) {
    errorMessage.push('at least one number')
  }

  if (!LOWERCASE_REGEX.test(value)) {
    errorMessage.push('at least one lowercase letter')
  }

  if (!UPPERCASE_REGEX.test(value)) {
    errorMessage.push('at least one uppercase letter')
  }

  if (!SPECIAL_CHAR_REGEX.test(value)) {
    errorMessage.push('at least one special character')
  }

  if (errorMessage.length === 0) {
    return true
  }

  if (errorMessage.length === 1) {
    return `Must contain ${errorMessage.join('')}.`
  }

  errorMessage[errorMessage.length - 1] = `and ${errorMessage[errorMessage.length - 1]}`

  return `Must contain ${errorMessage.join(', ')}.`
}

defineRule('required', (value: string) => {
  return required(value) || 'This field is required.'
})

defineRule('email', (value: string) => {
  if (email(value) && max(value, { length: 254 })) {
    return true
  }

  return 'Please enter a valid email address.'
})

defineRule('confirmEmail', (value: string, [target]: string[]) => {
  if (required(value) && value === target) {
    return true
  }

  return 'Emails must match.'
})

defineRule('password', (value: string) => {
  const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,}$/

  if (
    required(value) &&
    min(value, { length: MIN_PASSWORD_LENGTH }) &&
    max(value, { length: 100 }) &&
    PASSWORD_REGEX.test(value)
  ) {
    return true
  }

  return validatePassword(value)
})

defineRule('confirmPassword', (value: string, [target]: string[]) => {
  if (required(value) && value === target) {
    return true
  }

  return 'Passwords must match.'
})
